<template>
  <div class>
    <div
      slot="header"
      class="clearfix"
      style="background-color: #f2f2f2; padding: 20px"
    >
      <span style="font-weight: 600; color: #000; line-height: 10px"
        >告警信息</span
      >
      <el-button
        type="success"
        plain
        @click="cancel"
        style="float: right; padding: 3px 0"
        >返回</el-button
      >
    </div>
    <SForm
      ref="formref"
      :fields="formfields"
      :dataForm="tableData"
      labelWidth="150px"
      :isShowBtn="false"
      :inline="false"
    >
    </SForm>
    <div class="clearfix" style="background-color: #f2f2f2; padding: 20px">
      <span style="font-weight: 600; color: #000; line-height: 10px"
        >设备信息</span
      >
    </div>
    <SForm
      ref="formrefDevice"
      :fields="formfieldsDevice"
      :dataForm="tableData"
      labelWidth="150px"
      :isShowBtn="false"
      :inline="false"
    >
    </SForm>
  </div>
</template>

<script>
const token = window.localStorage.getItem("token");
export default {
  name: "offlineAlarmDetail",
  components: {},
  data() {
    return {
      formfields: [
        {
          label: "离线发生时间",
          type: "div",
          prop: "happenTime",
        },
        {
          label: "离线恢复时间",
          type: "div",
          prop: "recoverTime",
        },
        {
          label: "离线时长",
          type: "div",
          prop: "offlineTime",
        },
        {
          label: "异常状态",
          type: "div",
          prop: "status",
        },
        {
          label: "短信通知",
          type: "div",
          prop: "sendSms",
        },
      ],
      formfieldsDevice: [
        {
          label: "SN号",
          type: "div",
          prop: "SN",
        },
        {
          label: "设备名称",
          type: "div",
          prop: "deviceName",
        },
        {
          label: "品牌型号",
          type: "div",
          prop: "brandModel",
        },
        {
          label: "项目名称",
          type: "div",
          prop: "projectName",
        },
        {
          label: "企业名称",
          type: "div",
          prop: "companyName",
        },
      ],
      id: "",
      tableData: {},
    };
  },
  computed: {},
  methods: {
    cancel() {
      this.$router.go(-1);
    }
  },
  mounted() {
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    this.tableData = this.$route.query.data;
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color:#00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/offlineAlarm/offlineAlarmDetail.vue